import table from '../table/lv-base-table'
import tableColumn from './column/lv-column'
import tableColumnGroup from '../table/lv-column-group'
import tableColumnIndex from './index/lv-column-index'

import tableColumnDatepicker from './datepicker/link-table-column-datepicker'
import tableColumnTimepicker from './timepicker/link-table-column-timepicker'
import tableColumnInput from './input/link-table-column-input'
import tableColumnLov from './lov/link-table-column-lov'
import tableColumnCheck from './check/link-table-column-check'
import tableColumnObject from './object/link-table-column-object'
import tableColumnRadio from './radio/link-table-column-radio'
import tableColumnMvg from './mvg/link-table-column-mvg'
import tableColumnInputNumber from './input-number/link-table-column-input-number'
import tableColumnSelect from './select/link-table-column-select'
import tableColumnCheckbox from './checkbox/link-table-column-checkbox'
import tableColumnToggle from './toggle/link-table-column-toggle'
import tableColumnAddress from './address/link-table-column-address'
import tableColumnImg from './img/link-table-column-image'
import tableColumnTextarea from './textarea/link-table-column-textarea'
import tableColumnOperate from './operate/link-table-column-operate'
import tableColumnTree from './tree/link-table-column-tree'

import tableCellNormal from '../table/lv-table-cell-normal'

const tableColumnComponents = {

	table,
	baseTable: table,
	tableColumn,
	tableColumnGroup,
	tableCellNormal,

	tableColumnIndex,
	tableColumnDatepicker,
	tableColumnTimepicker,
	tableColumnInput,
	tableColumnLov,
	tableColumnCheck,
	tableColumnObject,
	tableColumnRadio,
	tableColumnMvg,
	tableColumnInputNumber,
	tableColumnSelect,
	tableColumnCheckbox,
	tableColumnToggle,
	tableColumnAddress,
	tableColumnImg,
	tableColumnTextarea,
	tableColumnOperate,
	tableColumnTree,
}

export {
	tableColumnComponents
}
